import { useMutation, useQuery } from '@tanstack/react-query';
import * as employeesApi from '../api/employeesApi';
import { toaster } from '../components/ui/toast';
import { logApiError } from '../utils/logger';
import { getApiErrorMessage } from '../utils/apiErrors';

export const useBusinessPositions = (businessId?: string | null, enabled = true) =>
  useQuery({
    queryKey: ['business-positions', businessId],
    enabled: enabled && !!businessId,
    staleTime: 5 * 60_000,
    queryFn: async () => {
      const res = await employeesApi.listBusinessPositions(businessId as string) as unknown as { positions: employeesApi.BusinessPosition[] };
      return res.positions ?? [];
    },
  });

export const useCreateBusinessEmployee = (businessId?: string | null) =>
  useMutation({
    mutationFn: (body: employeesApi.CreateEmployeeRequest) => employeesApi.createBusinessEmployee(businessId as string, body),
    onError: (error: unknown) => {
      logApiError('Error adding a team member:', error);
      toaster.negative(getApiErrorMessage(error, 'Could not add the team member'), { autoHideDuration: 5000 });
    },
  });
